module.exports = __webpack_public_path__ + "static/media/U1-T1-05A.9c701bf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-05A.jpg
// module id = 551
// module chunks = 0